export * from './src/bookings-availability-v2-time-slot-availability-time-slots.schemas.js';
